import { useEffect, useState } from 'react'
const useCountdown = (targetTime, interval = 1000) => {
  const target = new Date(targetTime).getTime()
  const calc = () => {
    if (!target) return 0
    const now = new Date().getTime()
    const diff = target - now
    return Math.max(0, diff / 1000)
  }
  const [remain, setRemain] = useState(calc())
  useEffect(() => {
    if (!targetTime) return
    setRemain(calc())
    const timer = setInterval(() => {
      setRemain(calc())
    }, interval)
    return () => clearInterval(timer) 
  }, [targetTime])
  const seconds = Math.floor(remain) % 60
  const minutes = Math.floor(remain / 60) % 60
  const hours = Math.floor(remain / 60 / 60 ) % 24
  const days = Math.floor(remain / 60 / 60 / 24)
  return { days, hours, minutes, seconds }
}

export default useCountdown